import { PageHero } from "@/components/site/PageHero";
import { Reveal, Overline } from "@/components/site/Reveal";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { company } from "@/data/content";
import { Phone, Mail, MapPin, Clock, FileText } from "lucide-react";

const details = [
  { icon: Phone, label: "Call us", value: company.phone, href: `tel:${company.phone.replace(/\s/g, "")}` },
  { icon: Mail, label: "Email us", value: company.email, href: `mailto:${company.email}` },
  { icon: MapPin, label: "Head office", value: company.address },
  { icon: Clock, label: "Availability", value: company.coverage },
];

export default function Contact() {
  return (
    <div>
      <PageHero
        overline="Contact Us"
        title={["Talk to the", "team behind", "your buildings."]}
        subtitle="Whether you have a live requirement or just want to understand how integrated facilities management could work for you, we're here to help."
      />

      <section className="bg-ink py-16 md:py-24 border-t border-border">
        <div className="max-w-container mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal><Overline>Get in touch</Overline></Reveal>
            <div className="mt-10 space-y-4">
              {details.map((d) => {
                const Icon = d.icon;
                const content = (
                  <div className="flex items-start gap-4 bg-surface border border-border p-6 hover:border-brand/50 transition-colors duration-300">
                    <Icon size={22} className="text-brand-light mt-1 shrink-0" />
                    <div>
                      <div className="text-xs uppercase tracking-[0.15em] text-slatetxt">{d.label}</div>
                      <div className="mt-1 text-white text-lg">{d.value}</div>
                    </div>
                  </div>
                );
                return (
                  <Reveal key={d.label}>
                    {d.href ? <a href={d.href} className="block">{content}</a> : content}
                  </Reveal>
                );
              })}
              <Reveal>
                <div className="flex items-start gap-4 bg-surface border border-border p-6">
                  <FileText size={22} className="text-brand-light mt-1 shrink-0" />
                  <div>
                    <div className="text-xs uppercase tracking-[0.15em] text-slatetxt">Registered</div>
                    <div className="mt-1 text-white">{company.reg}</div>
                    <div className="text-slatetxt text-sm">{company.vat}</div>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <EnquiryForm type="contact" />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
